/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_2_AInputs */

const en_control_faq_2_a = /** @type {(inputs: Control_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Your choices are saved in this browser and can be shared through a URL.`)
};

const zh_control_faq_2_a = /** @type {(inputs: Control_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不需要，选择保存在浏览器中，也能通过链接分享。`)
};

/**
* | output |
* | --- |
* | "No. Your choices are saved in this browser and can be shared through a URL." |
*
* @param {Control_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_2_a = /** @type {((inputs?: Control_Faq_2_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_2_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_2_a(inputs)
	return zh_control_faq_2_a(inputs)
});
export { control_faq_2_a as "control.faq.2.a" }